module.exports = __webpack_public_path__ + "img/booking-opened-selected.adcb6ca8.svg";